// import Definition from './Definition';

export default {
  priority: 100,
  name: app.translate('routes.home.attendance.setting.Definition'),
  path: 'definition',
  // component: Definition,
  component: load(() => import(/* webpackChunkName: "Setting-Definition" */ './Definition')),
  permissions: ['TimeAttendanceMenu/Settings/SettingDefinitionMenu'],
  icon: 'content-paste',
  drawer: true,
};


